<ng-container *ngIf="ready && actionText">
  <h4 class="calltoaction mw568 indent" dir="{{ dir$ | async }}">
    {{ actionText }}
  </h4>
</ng-container>
